const list = {
  // =================================================================================================================
  components () {
    return [
      {'component': 'search-start-end', label: '평가일', value:'date', query:{'ss':'startDate', 'ee':'endDate'}, options:{}},
      {'component': 'search-column-keyword', label: '검색조건', value:'column', query:{'ck_t':'head', 'ck_k':'keyword'},
        options: { hiddenList: ['평가일']}},
    ]
  },
  getConditions: (nav) => {
    const conditions = [];
    const search = nav.value;

    //  평가일
    if (search.date) {
      conditions.push({key: 'body.stdInfo.평가일', operator: '>=', value: search.date.startDate})
      conditions.push({key: 'body.stdInfo.평가일', operator: '<', value: search.date.endDate ? new Date(search.date.endDate).addDays(1).format("yyyy-MM-dd") : ''})
    }

    //  검색조건
    const types = {
      '사업장명': '',
      '업체명': '',
      '평가점수': '',
      '소속명': '',
      '부서명': '',
      '작성자': '',
    }
    if (search.column && search.column.keyword) {
      conditions.push({key: types[search.column.head], operator: 'LIKE', value: `%${search.column.keyword}%`})
    }
    return conditions;
  },


  // =================================================================================================================
  getHead: () => {
    return [
      {name: '사업장명', key: 'body.stdInfo.field_name'},
      {name: '업체명', key: 'body.companyName'},
      {name: '평가일', key: 'body.stdInfo.평가일'},
      {name: '평가점수', key: 'body.userScore'},
      {name: '소속명', key: 'body.stdInfo.department'},
      {name: '팀명', key: 'body.stdInfo.section'},
      {name: '작성자', key: 'body.stdInfo.writer_name'},
    ]
  },
  getCol: (index, value, func) => {
    try {
      switch (index) {
      case 0: return func.getContent(value).stdInfo.field_name // 사업장명
      case 1: return func.getContent(value).companyName // 업체명
      case 2: return func.getContent(value).stdInfo.평가일 // 평가일
      case 3: return func.getContent(value).userScore // 평가점수
      case 4: return func.getContent(value).stdInfo.department // 소속명
      case 5: return func.getContent(value).stdInfo.section // 부서명
      case 6: return func.getContent(value).stdInfo.writer_name // 작성자
      }
    } catch (e) { /*ignore*/ }
    return ''
  },
  getSearchKeyValue: (nav) => {},
  getSearchKeyword: (nav) => {},
}
export default list;
